module.exports = __webpack_public_path__ + "static/fonts/roboto-regular.99433f7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/roboto-regular.woff
// module id = GDyk
// module chunks = 1